import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import { LogoutUser } from "../Auth";
import { toast } from "react-toastify";

export interface ChangePasswordData {
  user_id: string;
  email: string;
  old_password: string;
  new_password: string;
  new_password_confirmation: string;
}

interface ChangePasswordState {
  ChangePassword: {
    load: boolean;
    data: Array<ChangePasswordData>;
    error: {
      old_password?: string;
      new_password?: string;
      new_password_confirmation?: string;
      [key: string]: string | undefined;
    };
  };
  ChangePasswordData?: ChangePasswordData;
}
const initialState = {
  ChangePassword: {
    load: false,
    data: [],
    error: {
      old_password: "",
      new_password: "",
      new_password_confirmation: "",
    },
  },
  ChangePasswordData: {
    user_id: "",
    email: "",
    old_password: "",
    new_password: "",
    new_password_confirmation: "",
  },
} as ChangePasswordState;

export const UpdatePasswordSlice = createSlice({
  name: "ChangePassword",
  initialState,
  reducers: {
    resetChangePasswordData: (state: ChangePasswordState) => {
      state.ChangePasswordData = initialState.ChangePasswordData;
    },
    updateChangePasswordData: (
      state: ChangePasswordState,
      action: { payload: ChangePasswordData }
    ) => {
      state.ChangePasswordData = action.payload;
    },
    updateChangePasswordDataFail: (state, action) => {
      state.ChangePassword.error = action.payload.message.errors;
    },
    clearChangePasswordFieldError: (
      state,
      action: { payload: keyof ChangePasswordState["ChangePassword"]["error"] }
    ) => {
      if (state.ChangePassword.error) {
        delete state.ChangePassword.error[action.payload];
      }
    },
  },
});
export const {
  updateChangePasswordData,
  resetChangePasswordData,
  updateChangePasswordDataFail,
  clearChangePasswordFieldError 
} = UpdatePasswordSlice.actions;
export default UpdatePasswordSlice.reducer;

export const postChangePassword = createAsyncThunk(
  "ChangePassword/postChangePassword",
  async (param: { apiParam: any; navigation: any }, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());

      const { data } = await DataServer.post(
        "api/changePassword",
        param.apiParam
      );

      thunkAPI.dispatch(toggleLoading());

      if (
        data.message ===
        "Previous passwords cannot be reused. Choose a different password."
      ) {
        toast.warning(data.message, { theme: "colored" });
      } else {
        toast.success(data.message, {
          theme: "colored",
          onClose: () => {
            handleonConfirm();
          },
        });

        const handleonConfirm = () => {
          param.navigation("/dashboard");
          thunkAPI.dispatch(LogoutUser(param.navigation));
        };
      }

      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
      thunkAPI.dispatch(
        updateChangePasswordDataFail({
          message: error,
        })
      );
      return error;
    }
  }
);
